<template>
  <div style="background:#f5f5f5;">
    <div>
      <Search/>
    </div>
    <div class="content__main--div">
      <ProductCard :options="cardOptions"/>
    </div>
  </div>
</template>
<script>
import Search from './components/Search'
import ProductCard from './components/ProductCard'
export default {
  name:'Product',
  components:{
    Search,
    ProductCard
  },
  data(){
    return {
      cardOptions:[
        {
          title:'定制产品附属',
          cost:'399￥/月',
          contentArr:['移动端跨端收费，Web端免费','付费用户: ','支持导出工程及组件/页面代码','移动端支持自动打包'],
          price: 399
        },
        {
          title:'企业私有部署版',
          cost:'1299￥/账号 月',
          contentArr:['按账号收费','支持SaaS版的所有功能','定期升级','不少于 30个账号（开通账号需联系我们）','无项目数量限制'],
          price: 1299
        },
        {
          title:'企业私有部署版',
          cost:'50万/(年*站点)',
          contentArr:['无限账号收费','可以连接外网，并同步低代码开发平台平台的组件库，极大的丰富用户可选组件库','定期升级（需要支持远程升级权限）','无账号数量限制','无项目数量限制'],
          price: 500000
        },
        {
          title:'企业私有部署版',
          cost:'80万/(站点)',
          contentArr:['完全内网隔离环境部署','内置平台上所有已支持的组件库','定期升级（每年升级一次）','无账号数量限制','无项目数量限制'],
          price: 800000
        },
        {
          title:'个人开发者',
          cost:'179.9￥/月',
          contentArr:['按项目数量付费','停止付费后','所有的项目内容均不允许编辑','停止付费再付费部分项目','需要指定哪些项目继续付费']
        },
        {
          title:'团队账号',
          cost:'329.9￥/月',
          contentArr:['按照项目成员数量进行收费','至少3个账号','团队内的活动项目数量最高不超过10个','可以将项目进行归档操作','归档后的项目属于不活动项目']
        },
        {
          title:'企业账号',
          cost:'649.9￥/月',
          contentArr:['按照项目成员数量进行收费','至少10个账号','团队内的活动项目数量最高不超过10个','可以将项目进行归档操作，归档后的项目属于不活动项目','活跃的团队数量最高不超过20个','可以将团队尽心归档操作，归档后团队内的项目都属于不活动项目']
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>